(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["al-language-bar"] && !Shopify.designMode) return;
  try {
    
if (!window.alLanguageUxBound) {
  window.alLanguageUxBound = true;
  document.addEventListener('click', function(event) {
    document.querySelectorAll('.al-language-picker[open]').forEach(function(picker) {
      if (!picker.contains(event.target)) picker.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', function(event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.al-language-picker[open]').forEach(function(picker) {
      picker.removeAttribute('open');
      picker.querySelector('summary').focus();
    });
  });
  document.addEventListener('submit', function(event) {
    if (!event.target.matches('.al-language-picker__form')) return;
    var field = event.target.querySelector('input[name="return_to"]');
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = 'return_to';
      event.target.appendChild(field);
    }
    var button = event.target.querySelector('button[data-return-to]');
    var destination = new URL(button.dataset.returnTo, window.location.origin);
    destination.search = window.location.search;
    destination.hash = window.location.hash;
    field.value = destination.pathname + destination.search + destination.hash;
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();
        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-cloud9"] && !Shopify.designMode) return;
  try {
    
function initRfc(root){
  if(root.dataset.ready)return;
  root.querySelectorAll('.rfc-clean video,.rfc-chew video').forEach(cleanVideo=>{
    cleanVideo.defaultMuted=true;
    cleanVideo.muted=true;
    cleanVideo.playsInline=true;
    cleanVideo.autoplay=true;
    cleanVideo.loop=true;
    cleanVideo.setAttribute('muted','');
    cleanVideo.setAttribute('playsinline','');
    cleanVideo.setAttribute('webkit-playsinline','');
    cleanVideo.setAttribute('autoplay','');
    cleanVideo.controls=false;
    cleanVideo.removeAttribute('controls');
    cleanVideo.tabIndex=0;
    const videoTitle=cleanVideo.closest('section').querySelector('h2');
    if(videoTitle)cleanVideo.setAttribute('aria-label',videoTitle.textContent.trim());
    let controlsTimer=0;
    const hideControls=()=>{clearTimeout(controlsTimer);cleanVideo.controls=false;};
    const deferHideControls=()=>{
      clearTimeout(controlsTimer);
      if(!cleanVideo.paused)controlsTimer=setTimeout(hideControls,3000);
    };
    const showControls=()=>{cleanVideo.controls=true;deferHideControls();};
    cleanVideo.addEventListener('click',event=>{
      if(!cleanVideo.controls){event.preventDefault();showControls();}
      else deferHideControls();
    });
    cleanVideo.addEventListener('pointerdown',()=>{if(cleanVideo.controls)clearTimeout(controlsTimer);});
    cleanVideo.addEventListener('pointerup',()=>{if(cleanVideo.controls)deferHideControls();});
    cleanVideo.addEventListener('keydown',event=>{
      if(event.key==='Enter'||event.key===' '){
        event.preventDefault();showControls();
        if(cleanVideo.paused)playVisible();else cleanVideo.pause();
      }else if(event.key==='Escape')hideControls();
    });
    cleanVideo.addEventListener('focus',showControls);
    cleanVideo.addEventListener('play',()=>{if(cleanVideo.controls)deferHideControls();});
    cleanVideo.addEventListener('pause',()=>{
      clearTimeout(controlsTimer);
      if(visible())cleanVideo.controls=true;
    });
    let inView=false,pending=false,blocked=false,frame=0;
    const visible=()=>{
      const r=cleanVideo.getBoundingClientRect();
      const height=window.innerHeight||document.documentElement.clientHeight;
      const width=window.innerWidth||document.documentElement.clientWidth;
      return !document.hidden&&r.width>0&&r.height>0&&r.right>0&&r.left<width&&Math.min(r.bottom,height)-Math.max(r.top,0)>=Math.min(80,r.height*.15);
    };
    const playVisible=()=>{
      if(!visible()||pending||!cleanVideo.paused)return;
      pending=true;
      try{
        const attempt=cleanVideo.play();
        Promise.resolve(attempt).then(()=>{
          pending=false;blocked=false;
          if(!visible())cleanVideo.pause();
        }).catch(()=>{pending=false;blocked=true;showControls();});
      }catch(error){pending=false;blocked=true;showControls();}
    };
    const sync=()=>{
      frame=0;
      const next=visible();
      if(!next){cleanVideo.pause();hideControls();inView=false;return;}
      const entered=!inView;
      inView=true;
      if(entered)playVisible();
    };
    const queue=()=>{if(!frame)frame=requestAnimationFrame(sync);};
    if('IntersectionObserver' in window){
      const observer=new IntersectionObserver(sync,{threshold:[0,.05,.15,.25,.5,1]});
      observer.observe(cleanVideo);
    }
    window.addEventListener('scroll',queue,{passive:true});
    window.addEventListener('resize',queue,{passive:true});
    window.addEventListener('pageshow',()=>{inView=false;sync();});
    document.addEventListener('visibilitychange',()=>{inView=false;sync();});
    cleanVideo.addEventListener('loadeddata',playVisible,{once:true});
    cleanVideo.addEventListener('canplay',()=>{if(blocked||inView)playVisible();});
    const retryFromGesture=event=>{
      if(event.target===cleanVideo)return;
      if(blocked&&visible())playVisible();
    };
    document.addEventListener('touchend',retryFromGesture,{passive:true});
    document.addEventListener('pointerup',retryFromGesture,{passive:true});
    sync();
  });
  const vent=root.querySelector('.rfc-vent-visual');
  if(vent&&!matchMedia('(prefers-reduced-motion: reduce)').matches){
    let ventQueued=false;
    const drawVent=()=>{ventQueued=false;const rect=vent.getBoundingClientRect();const progress=Math.max(0,Math.min(1,(innerHeight*.5-rect.top)/innerHeight));const phase=(progress*3)%1;
      vent.querySelectorAll('.rfc-air-arrow').forEach((arrow,index)=>{const side=index===1?-1:index===2?1:0;arrow.style.opacity=String(1-phase);arrow.style.transform='translate('+side*(rect.width*.105+100*phase)+'px,'+(-100*phase)+'px) rotate('+(side*30)+'deg) scale('+(index===0?1+2*phase:.75+.75*phase)+')';});};
    const queueVent=()=>{if(!ventQueued){ventQueued=true;requestAnimationFrame(drawVent);}};
    window.addEventListener('scroll',queueVent,{passive:true});window.addEventListener('resize',queueVent);drawVent();
  }
  root.dataset.ready='true';

  function selectSize(size){
    if(!['small','medium','large','xxl'].includes(size))return;
    root.querySelectorAll('[data-rfc-panel]').forEach(function(panel){panel.hidden=panel.dataset.rfcPanel!==size});
    root.querySelectorAll('[data-rfc-tab]').forEach(function(button){button.setAttribute('aria-pressed',String(button.dataset.rfcTab===size))});
  }

  function showBed(size){
    selectSize(size);
    requestAnimationFrame(()=>{const panel=root.querySelector('[data-rfc-panel="'+size+'"]');if(!panel)return;const header=document.querySelector('.section-header');const offset=header?Math.min(220,header.getBoundingClientRect().height+16):190;window.scrollTo({top:window.scrollY+panel.getBoundingClientRect().top-offset,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});history.replaceState(null,'','#rfc-bed-'+size)});
  }
  root.querySelectorAll('a[href="#rfc-shop"]:not([data-rfc-size]):not([data-rfc-result-link])').forEach(link=>link.addEventListener('click',e=>{e.preventDefault();const size=link.dataset.rfcSize||root.querySelector('[data-rfc-tab][aria-pressed="true"]').dataset.rfcTab;showBed(size)}));
  const requested=new URLSearchParams(location.search).get('size');
  if(requested)selectSize(requested);
  root.querySelectorAll('[data-rfc-size]').forEach(function(link){link.addEventListener('click',function(event){event.preventDefault();showBed(link.dataset.rfcSize)})});
  root.querySelectorAll('[data-rfc-tab]').forEach(function(button){button.addEventListener('click',function(){selectSize(button.dataset.rfcTab)})});
  root.querySelectorAll('[data-rfc-fabric]').forEach(function(select){
    select.addEventListener('change',function(){
      const panel=select.closest('[data-rfc-panel]');
      const option=select.selectedOptions[0];
      const image=panel.querySelector('.rfc-product-img');
      panel.querySelector('[data-rfc-price]').textContent=option.dataset.price;
      panel.querySelector('[data-rfc-product-link]').href=option.value;
      image.removeAttribute('srcset');
      image.src=option.dataset.image;
    });
  });

  const breed=root.querySelector('[data-rfc-breed]');
  if(breed){
    const rows=JSON.parse(root.querySelector('[data-rfc-breed-data]').textContent);
    const list=root.querySelector('[data-rfc-breed-options]'),status=root.querySelector('[data-rfc-breed-status]'),result=root.querySelector('[data-rfc-result]');
    const normal=s=>s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]+/g,' ').trim();
    const distance=(a,b)=>{let prev=Array.from({length:b.length+1},(_,i)=>i);for(let i=1;i<=a.length;i++){const next=[i];for(let j=1;j<=b.length;j++)next[j]=Math.min(next[j-1]+1,prev[j]+1,prev[j-1]+(a[i-1]===b[j-1]?0:1));prev=next}return prev[b.length]};
    rows.forEach(r=>r.names=[r.breed,...r.aliases].map(normal));
    const breedSelect=root.querySelector('[data-rfc-breed-select]');
    const dogName=root.querySelector('[data-fit-dog-name]');
    const empty=root.querySelector('[data-fit-empty]');
    const initialName=dogName.textContent;
    const sizeIcons=Array.from(root.querySelectorAll('[data-fit-size]'));
    rows.forEach((r,i)=>{const option=document.createElement('option');option.value=String(i);option.textContent=r.breed;breedSelect.append(option)});
    const resetFit=()=>{root.querySelector('[data-fit-height]').textContent='—';root.querySelector('[data-fit-weight]').textContent='—';root.querySelector('[data-rfc-result-copy]').textContent='—';result.hidden=true;empty.hidden=false;dogName.textContent=initialName;sizeIcons.forEach(el=>el.classList.remove('is-selected'));breedSelect.value='';};
    let matches=[],active=-1;
    const close=()=>{list.hidden=true;breed.setAttribute('aria-expanded','false');breed.removeAttribute('aria-activedescendant');active=-1};
    const choose=r=>{root.querySelector('[data-fit-height]').textContent=r.height?r.height+' cm':status.dataset.varies;root.querySelector('[data-fit-weight]').textContent=r.weight?r.weight+' kg':status.dataset.varies;breedSelect.value=String(rows.indexOf(r));dogName.textContent=r.breed;empty.hidden=true;sizeIcons.forEach(el=>el.classList.toggle('is-selected',el.dataset.fitSize===r.size));const icon=sizeIcons.find(el=>el.dataset.fitSize===r.size);result.querySelector('[data-fit-dimensions]').textContent=icon?icon.querySelector('small').textContent:'';breed.value=r.breed;close();status.textContent='';result.hidden=false;const label=r.size?root.querySelector('[data-rfc-tab="'+r.size+'"]').textContent:status.dataset.measure;result.querySelector('[data-rfc-result-size]').textContent=label;result.querySelector('[data-rfc-result-breed]').textContent=r.breed;root.querySelector('[data-rfc-result-copy]').textContent=r.text.replace(/&quot;/g,'\"').replace(/&#39;|&apos;/g,"'").replace(/&amp;/g,'&');result.querySelector('[data-rfc-result-link]').href=r.size?'#rfc-bed-'+r.size:'#rfc-sizes';result.querySelector('[data-rfc-result-link]').onclick=e=>{if(r.size){e.preventDefault();showBed(r.size)}}};
    const search=()=>{resetFit();const q=normal(breed.value);list.replaceChildren();active=-1;breed.removeAttribute('aria-activedescendant');if(!q){close();status.textContent='';return}const ranked=rows.map(r=>({r,score:Math.min(...r.names.map(n=>n===q?0:n.startsWith(q)?1:n.includes(q)?2:q.split(' ').every(w=>n.includes(w))?3:q.length>=4&&distance(q,n)<=2?4:99))})).filter(x=>x.score<99).sort((a,b)=>a.score-b.score||a.r.breed.localeCompare(b.r.breed));matches=ranked.slice(0,10).map(x=>x.r);matches.forEach((r,i)=>{const li=document.createElement('li');li.id=list.id+'-'+i;li.setAttribute('role','option');li.setAttribute('aria-selected','false');li.textContent=r.breed+(rows.filter(x=>x.breed===r.breed).length>1?' · '+r.size:'');li.addEventListener('pointerdown',e=>e.preventDefault());li.addEventListener('click',()=>choose(r));list.append(li)});status.textContent=ranked.length?ranked.length+' '+status.dataset.found:status.dataset.none;list.hidden=!matches.length;breed.setAttribute('aria-expanded',String(!!matches.length))};
    breedSelect.addEventListener('change',()=>{if(breedSelect.value===''){breed.value='';resetFit();close();status.textContent='';}else choose(rows[Number(breedSelect.value)]);});
    breed.addEventListener('input',search);breed.addEventListener('focus',()=>{if(result.hidden)search()});
    breed.addEventListener('keydown',e=>{if(e.key==='Escape'){close();return}if(e.key==='Enter'&&!list.hidden&&matches.length){e.preventDefault();choose(matches[active<0?0:active]);return}if((e.key==='ArrowDown'||e.key==='ArrowUp')&&matches.length){e.preventDefault();list.hidden=false;breed.setAttribute('aria-expanded','true');active=(active+(e.key==='ArrowDown'?1:-1)+matches.length)%matches.length;[...list.children].forEach((li,i)=>li.setAttribute('aria-selected',String(i===active)));breed.setAttribute('aria-activedescendant',list.children[active].id);list.children[active].scrollIntoView({block:'nearest'})}});
    breed.addEventListener('blur',()=>setTimeout(close,150));
  }

  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealTargets=root.querySelectorAll('.rfc-promise,.rfc-heading,.rfc-size,.rfc-style,.rfc-feature-copy,.rfc-story-grid figure,.rfc-product,.rfc-faq details');
  revealTargets.forEach(function(element){element.setAttribute('data-rfc-reveal','')});
  if(reduced){
    revealTargets.forEach(function(element){element.classList.add('is-visible')});
  }else{
    const observer=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target)}});
    },{rootMargin:'0px 0px -8% 0px',threshold:.08});
    revealTargets.forEach(function(element){observer.observe(element)});

    const hero=root.querySelector('.rfc-hero');
    const dream=root.querySelector('[data-rfc-dream]');
    const headline=root.querySelector('h1');
    if(headline) root.style.setProperty('--rfc-heading-font',getComputedStyle(headline).fontFamily);
    const impactSections=root.querySelectorAll('.rfc-impact');
    const lifeClocks=Array.from(root.querySelectorAll('[data-rfc-lifetime]')).map(function(el){return {el:el,year:el.querySelector('[data-age-year]'),stage:el.querySelector('[data-age-stage]')};});
    let ticking=false;
    function paint(){
      if(hero&&dream){
        const rect=hero.getBoundingClientRect();
        const progress=Math.max(0,Math.min(1,(window.innerHeight*.65-rect.bottom)/Math.max(window.innerHeight*.65,1)));
        dream.style.setProperty('--rfc-original-y',(Math.max(-1,Math.min(1,-rect.top/Math.max(rect.height,1)))*32).toFixed(2)+'px');
        dream.style.setProperty('--rfc-original-opacity',String(1-progress));
      }
      impactSections.forEach(function(section){
        const rect=section.getBoundingClientRect();
        const progress=(window.innerHeight-rect.top)/(window.innerHeight+rect.height);
        section.style.setProperty('--rfc-bg-y',(42+Math.max(0,Math.min(1,progress))*16).toFixed(2)+'%');
        if(section.classList.contains('rfc-life')){
          const travel=Math.max(1,window.innerHeight*.70);
          const entered=Math.max(0,Math.min(1,(window.innerHeight*.85-rect.top)/travel));
          const spread=1-entered*entered*(3-2*entered);
          const mobile=window.innerWidth<750;
          const distance=mobile?18:28;
          section.style.setProperty('--rfc-life-title-scale',(1-.025*spread).toFixed(4));
          section.style.setProperty('--rfc-life-title-x',(-distance*spread).toFixed(2)+'px');
          section.style.setProperty('--rfc-life-title-y',(-(mobile?32:48)*spread).toFixed(2)+'px');
          section.style.setProperty('--rfc-life-copy-x',(distance*.55*spread).toFixed(2)+'px');
          section.style.setProperty('--rfc-life-copy-y',((mobile?26:38)*spread).toFixed(2)+'px');
        }
      });
      lifeClocks.forEach(function(clock){
        const top=clock.el.getBoundingClientRect().top;
        const p=Math.max(0,Math.min(1,(window.innerHeight*.85-top)/Math.max(1,window.innerHeight*.55)));
        const smooth=function(v){v=Math.max(0,Math.min(1,v));return v*v*(3-2*v);};
        const adult=smooth((p-.20)/.20);
        const senior=smooth((p-.65)/.20);
        clock.el.style.setProperty('--age-puppy',String(1-adult));
        clock.el.style.setProperty('--age-adult',String(adult*(1-senior)));
        clock.el.style.setProperty('--age-senior',String(senior));
        clock.el.style.setProperty('--age-turn',(p*360).toFixed(2)+'deg');
        clock.el.style.setProperty('--age-offset',String(1-p));
        const year=String(2026+Math.round(p*10));
        const stage=p<.30?clock.el.dataset.puppy:p<.75?clock.el.dataset.adult:clock.el.dataset.senior;
        if(clock.year.textContent!==year)clock.year.textContent=year;
        if(clock.stage.textContent!==stage)clock.stage.textContent=stage;
      });
      ticking=false;
    }
    function requestPaint(){if(!ticking){window.requestAnimationFrame(paint);ticking=true}}
    window.addEventListener('scroll',requestPaint,{passive:true});
    window.addEventListener('resize',requestPaint);
    paint();
  }
}
document.querySelectorAll('[data-rfc]').forEach(initRfc);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-rfc]').forEach(initRfc));

if(!customElements.get('rfc-reveal'))customElements.define('rfc-reveal',class extends HTMLElement{
connectedCallback(){if(this.abort)return;this.abort=new AbortController();const signal=this.abort.signal;this.layers=['top','wall','protector','core','base'].map(n=>this.querySelector('.rf-'+n));this.slider=this.querySelector('input');this.details=[...this.querySelectorAll('.rf-detail')];this.output=this.querySelector('.rf-copy');this.reduce=matchMedia('(prefers-reduced-motion: reduce)');this.frame=0;this.manual=false;this.classList.add('rf-ready');this.paint(0);this.slider.addEventListener('input',()=>{this.manual=true;this.paint(Number(this.slider.value)/100)},{signal});this.tick=()=>{if(this.frame)return;this.frame=requestAnimationFrame(()=>{this.frame=0;if(this.manual||this.reduce.matches)return;if(innerWidth<750){const stage=this.querySelector('.rf-stage'),r=stage.getBoundingClientRect(),header=document.querySelector('.section-header'),headerBottom=header?Math.max(0,header.getBoundingClientRect().bottom):100;const end=Math.min(innerHeight*.4,Math.max(100,headerBottom+24)),start=Math.max(end+120,innerHeight-stage.offsetHeight*.3);this.paint(Math.max(0,Math.min(1,(start-r.top)/(start-end))));return;}if(this.classList.contains('rf-short')||innerHeight<650)return;const r=this.getBoundingClientRect(),off=parseFloat(getComputedStyle(this).getPropertyValue('--rf-offset'))||0;const span=this.offsetHeight-this.querySelector('.rf-pin').offsetHeight;this.paint(Math.max(0,Math.min(1,(off-r.top)/Math.max(1,span))))})};window.addEventListener('scroll',()=>{this.manual=false;this.tick()},{passive:true,signal});window.addEventListener('resize',()=>{this.fit();this.paint(this.progress||0);this.tick()},{signal});this.fit();this.reduce.addEventListener('change',()=>{this.paint(this.reduce.matches?.6:0);this.tick()},{signal});if(this.reduce.matches)this.paint(.6);else this.tick()}
paint(p){this.progress=p;this.slider.value=Math.round(p*100);const stage=this.querySelector('.rf-stage'),H=stage.clientHeight,W=stage.clientWidth;const clamp=x=>Math.max(0,Math.min(1,x)),ease=x=>{x=clamp(x);return x*x*(3-2*x)};const closing=ease((p-.12)/.68),q=1-closing;const reveal=1-ease((p-.70)/.12);const gap=W<500?22:34,bounds=this.geometry(),ratios=bounds.map(b=>b[3]/b[2]);const groupRatio=ratios[1]+ratios[2]*.38;const width=Math.min(W*.93,(H-42-gap*3)/(ratios[0]+groupRatio+ratios[3]+ratios[4]));const heights=ratios.map(r=>r*width);const total=heights[0]+heights[1]+heights[2]*.38+heights[3]+heights[4]+gap*3;let y=(H-total)/2;const targets=[y];y+=heights[0]+gap;targets.push(y,y+heights[1]-heights[2]*.62);y+=heights[1]+heights[2]*.38+gap;targets.push(y);y+=heights[3]+gap;targets.push(y);const baseTop=H*.52,topBottom=baseTop+heights[4]*.13;const starts=[topBottom-heights[0],baseTop-heights[1]*.22,baseTop+heights[4]*.13,baseTop+heights[4]*.14,baseTop];this.layers.forEach((el,i)=>{if(!el)return;const box=el.parentElement,[x,y,bw,bh,nw,nh]=bounds[i];box.style.width=width+'px';box.style.height=heights[i]+'px';box.style.top=(starts[i]+(targets[i]-starts[i])*q)+'px';el.style.width=(width*nw/bw)+'px';el.style.height=(width*nh/bw)+'px';el.style.left=(-width*x/bw)+'px';el.style.top=(-width*y/bw)+'px';box.style.opacity=reveal*(i>0&&i<4?ease(q*4):1);if(i===0){const peel=Math.sin(q*Math.PI);box.style.transform='translateX(-50%) perspective(900px) rotateX('+(-14*peel)+'deg) rotateZ('+(-2.5*peel)+'deg)';}});const photo=this.querySelector('.rf-photo');if(photo){photo.style.width=(width*1536/870)+'px';photo.style.height=(width*1024/870)+'px';photo.style.top=(baseTop+heights[4]-width*852/870)+'px';photo.style.left='calc(50% - '+(width*815/870)+'px)';photo.style.opacity=1-reveal;}let idx=p<.28?0:p<.44?1:p<.6?2:p<.80?3:4;if(idx!==this.index){this.index=idx;this.output.replaceChildren(this.details[idx].content.cloneNode(true));}}

fit(){const pin=this.querySelector('.rf-pin');this.classList.toggle('rf-short',pin.scrollHeight>innerHeight);}
geometry(){return [[33,271,1615,405,1672,941],[31,346,1603,337,1672,941],[42,395,1588,209,1672,941],[50,329,1560,320,1672,941],[60,250,1560,475,1672,941]];}

disconnectedCallback(){this.abort?.abort();this.abort=null;cancelAnimationFrame(this.frame)}
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-flagship"] && !Shopify.designMode) return;
  try {
    
function initializeRf(root){
 if(root.dataset.ready)return;
 root.dataset.ready='true';
 function choose(size){
  if(!['small','medium','large','xxl'].includes(size))return;
  root.querySelectorAll('[data-rf-panel]').forEach(panel=>{panel.hidden=panel.dataset.rfPanel!==size;});
  root.querySelectorAll('button[data-rf-size]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.rfSize===size)));
 }
 const requested=new URLSearchParams(location.search).get('size');if(requested)choose(requested);
 root.querySelectorAll('[data-rf-size]').forEach(control=>control.addEventListener('click',()=>choose(control.dataset.rfSize)));
 root.querySelectorAll('[data-rf-fabric]').forEach(select=>select.addEventListener('change',()=>{
  const panel=select.closest('[data-rf-panel]'),option=select.selectedOptions[0],photo=panel.querySelector('.rf-selected-image');
  panel.querySelector('[data-rf-product-link]').href=option.value;
  panel.querySelector('[data-rf-price]').textContent=option.dataset.price;
  photo.removeAttribute('srcset');photo.src=option.dataset.image;
 }));
 root.querySelectorAll('[data-rf-play]').forEach(button=>button.addEventListener('click',()=>{
  const player=button.parentElement.querySelector('.rf-hero-player');player.hidden=false;const video=player.querySelector('video');if(video){video.focus();video.play().catch(()=>{});}
 }));
}
document.querySelectorAll('[data-rf-page]').forEach(initializeRf);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-rf-page]').forEach(initializeRf));

  } catch(e) { console.error(e); }
})();
})();
